import React, { Suspense, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import AwsBanner from "../components/AwsBanner/AwsBanner";

const TechnumBot = React.lazy(
  () => import("../components/TechnumBot/TechnumBot"),
);

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Technum Opus Pvt. Ltd.",
  url: "https://technumopus.com",
  logo: "https://technumopus.com/favicon.png",
  description:
    "ITES company delivering digital transformation, cloud solutions, AI integration, cybersecurity, and technology infrastructure for manufacturing and enterprise clients.",
  address: [
    {
      "@type": "PostalAddress",
      name: "Registered Office",
      streetAddress: "1601, Tower 4, Unitech Harmony, Nirvana Country, Sector 50",
      addressLocality: "Gurugram",
      addressRegion: "Haryana",
      postalCode: "122018",
      addressCountry: "IN",
    },
    {
      "@type": "PostalAddress",
      name: "Corporate Office",
      streetAddress:
        "1502, 15th Floor, M3M International Financial Center (IFC), Sector 66, Golf Course Extension Road",
      addressLocality: "Gurugram",
      addressRegion: "Haryana",
      postalCode: "122101",
      addressCountry: "IN",
    },
  ],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+91-8700-579-310",
    contactType: "sales",
    email: "connect@technumopus.com",
    availableLanguage: "English",
  },
  sameAs: ["https://www.linkedin.com/company/technumopus"],
};

const TechnumOpusLayout = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(organizationSchema);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="technumopus-layout">
      <AwsBanner />
      <Header />
      <main id="main-content" className="technumopus-main">
        <Outlet />
        <Suspense fallback={null}>
          <TechnumBot />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default TechnumOpusLayout;
